import styled, { css } from 'styled-components';
import { COLOURS, FONT_WEIGHT, isFocused } from '@belong/themes';
import { ButtonUnstyled } from '../../actions/ButtonUnstyled';
import { Icon } from '../../Icon';
import { StyledTextInput } from '../TextInput/TextInput';

export const DateInputWrapper = styled.div<{ showClearButton?: boolean }>`
  display: flex;
  align-items: center;

  ${StyledTextInput} {
    ${props =>
      props.showClearButton &&
      css`
        position: relative;
      `}
  }
`;

export const CalendarIcon = styled(Icon)`
  margin-left: -3.7rem;

  ${StyledTextInput}:focus + & {
    color: ${COLOURS.DARK_BLUE};
  }
`;

export const ClearBtn = styled(ButtonUnstyled).attrs({
  type: 'button'
})`
  margin-left: -6rem;
  z-index: 1;
  padding: 0.8rem;
  cursor: pointer;
  color: ${COLOURS.DARK_BLUE};
  font-weight: ${FONT_WEIGHT.SEMI_BOLD};

  &:focus {
    ${() => isFocused(true)}
  }

  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.2rem;
  }
`;
